export enum AttachmentTypeEnum {
  TDDA = 1,
  HealthTick = 2,
  SLAAttachment = 3,
}
